import StorageIcon from '@material-ui/icons/Storage';
import ComputerOutlined from '@material-ui/icons/ComputerOutlined';

import { OverridableComponent } from '@material-ui/core/OverridableComponent';
import { SvgIconTypeMap } from '@material-ui/core/SvgIcon';
import { Choice } from './shared/choices/domain/choices';

type ChoiceButton = {
  text: string;
  icon: OverridableComponent<SvgIconTypeMap>;
};

export const choices: { [key in Choice]: ChoiceButton } = {
  databases: {
    text: 'Databases',
    icon: StorageIcon,
  },
  compute: {
    text: 'Compute',
    icon: ComputerOutlined,
  },
};
